import { routes } from "../configs/constants/routes";
import { ConsultantRating, FeedbackModal } from "../models/Consultant";
import { CustomerRating } from "../models/CustomerUser";
import { customerRoute, formatRoute, userRoute } from "./route.utils";

export const getFeedbackData = (
	data: CustomerRating | ConsultantRating,
	isConsultant: boolean
): FeedbackModal => {
	let convertedData = {
		commentReceiver: {
			name: "",
			profileImage: "",
			link: "",
		},
		commenter: {
			name: "",
			link: "",
		},
		job: { orderNumber: "", id: "" },
		comment: "",
		rateList: [] as { value: number; title: string }[],
	};

	if (isConsultant) {
		convertedData.comment = data.comment ?? "";
		convertedData.job = data.job;
		convertedData.rateList = [
			{ value: data.performance, title: "CONSULTANT_JOB_RATE" },
			{ value: data.punctualityScore, title: "CONSULTANT_PUNCTUALITY_RATE" },
		];
		convertedData.commenter.name = data?.metadata?.createdBy?.firstName || "";
		convertedData.commenter.link = userRoute(data.customer.id, data.metadata.createdBy.id || "");
		convertedData.commentReceiver.name = `${data.consultant.firstName} ${data.consultant.lastName}`;
		convertedData.commentReceiver.profileImage = data.consultant.profile?.profilePicture ?? "";
		convertedData.commentReceiver.link = formatRoute(
			[routes.CONSULTANTS_DETAILS, routes.CONSULTANTS_PROFILE].join("/"),
			[data.consultant.id]
		);
	}
	// TODO: need to fix this when BE is available
	//  else {
	// }

	return convertedData;
};
